// extracted by mini-css-extract-plugin
export default {"animateVertical":"kR37ryM1YFUGirfjw3iv","verticalMove":"MycMsRVxQvVczXZ4cLeV","noAnimation":"sLBZPWEQo4WVEO9jwxzh"};